export default __webpack_public_path__ + "a7337a312cf68988ce8866548d28fc9f.png";